import { Fragment } from 'react';
import { Modal } from 'react-bootstrap';

const DescartarCambiosModal = ({ show, onHide, onConfirmar, productoYaCreado }) => {
    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Descartar cambios</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {productoYaCreado ? (
                        <div className="alert alert-warning mb-0">
                            El producto ya se creó en el sistema, pero todavía no tiene proveedor ni ubicación guardados.
                            <br />
                            Si cierras ahora, el producto se queda registrado sin proveedor ni ubicación; podrás completarlo después desde la tabla.
                        </div>
                    ) : (
                        <div className="alert alert-warning mb-0">
                            Tienes cambios sin guardar en este producto.
                            <br />
                            Si cierras ahora, se perderán.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={onHide}>
                        Seguir editando
                    </button>

                    <button type="button" className="btn btn-danger" onClick={onConfirmar}>
                        Descartar cambios
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default DescartarCambiosModal;
